﻿import { fetchJSON } from "./Helper"

export function getPictureOfTheDay(isExternalEnv: boolean) {
    fetchJSON("https://apps.rescuetrack.com/api/apps/pictureOfTheDay", false)
        .then(result => document.querySelector("body").style.backgroundImage = `url(${result.url})`)
        .catch(reason => console.log(reason))
}
